module.exports = __webpack_public_path__ + "static/media/time.68ca3592.svg";